jQuery(document).ready(function ($) {
	"use strict";

	heroCarousel();
	reviewsCarousel();
	clientsCarousel();

	function castingParagraphMarginTop() {
		let castingIntroHeight = $(
			".casting__intro .wp-block-columns"
		).outerHeight();
		let castingFormHeight = $(".casting__form").outerHeight();

		let castingFormPadding = castingIntroHeight - castingFormHeight;
		$(".casting__paragraph").css({
			"padding-top": castingFormPadding + "px",
		});
	}

	function heroCarousel() {
		$(".casting__intro-gallery ul").addClass("owl-carousel").owlCarousel({
			items: 1,
			margin: 20,
			autoplay: true,
			loop: true,
			dots: false,
			nav: false,
		});
	}

	function reviewsCarousel() {
		$(".casting__reviews-carousel .wp-block-group__inner-container")
			.addClass("owl-carousel")
			.owlCarousel({
				items: 1,
				margin: 20,
				autoplay: false,
				loop: true,
				dots: true,
				responsive: {
					0: {
						nav: false,
					},
					768: {
						nav: true,
						navText: [
							'<i class="fas fa-chevron-left"></i>',
							'<i class="fas fa-chevron-right"></i>',
						],
					},
				},
			});
	}

	function clientsCarousel() {
		$(".casting__clients .blocks-gallery-grid")
			.addClass("owl-carousel")
			.owlCarousel({
				margin: 20,
				autoplay: true,
				loop: true,
				dots: true,
				responsive: {
					0: {
						items: 1.5,
					},
					768: {
						items: 4,
						navText: [
							'<i class="fas fa-chevron-left"></i>',
							'<i class="fas fa-chevron-right"></i>',
						],
					},
				},
			});
	}
});
